import { render, staticRenderFns } from "./PCLicenseLink.vue?vue&type=template&id=43695dc8"
import script from "./PCLicenseLink.vue?vue&type=script&lang=js"
export * from "./PCLicenseLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports